import styled from 'styled-components'

export const BlackGlass = styled.div`
  position:absolute;
  display: flex;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.3);
  justify-content: center;
  align-items: center;
  position: fixed;
  top:0;
  left:0;
  z-index: 99999;
`
export const ConfirmationModal = styled.div`
  background: #fff;
  position: relative;
  max-width: 800px;
  width:20%;
  padding:2rem ; 
  align-items:stretch; 
  border-radius: 1.5rem;

  p {
    font-size: 1rem;
  }

  div {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: flex-end;

    button + button {
      margin-left: 1rem;
    }
  }
`